import {Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import React from 'react';
import {useTheme} from 'styled-components';
import {InstructionItemProps} from './types';

export function InstructionItem({title, description, iconName}: InstructionItemProps) {
	const {palette} = useTheme();

	return (
		<Stack direction="row" gap={1.5} alignItems="start">
			<Icon name={iconName} color={palette.primary.main} />
			<Stack>
				<Typography variant="body1" fontWeight={600}>
					{title}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					{description}
				</Typography>
			</Stack>
		</Stack>
	);
}
